



















import {Component, Vue, Prop} from 'vue-property-decorator';
import {EventBus} from "@/helpers/EventBus";
import {AlertChannel, AlertService, AlertSettingsRequest} from "@/services/AlertService";
import {Inject} from "vue-typedi";
import { Zone } from '@/model/Zone';

@Component
export default class AlertDeleteForm extends Vue {

    @Inject()
    alertService!: AlertService;

    @Prop() email: string;

    @Prop({default: {}}) zone: Zone;

    get storeId(): string {
        return sessionStorage.getItem("storeId");
    }

    public cancelEmailDeletion() {
        this.$emit("cancelDeletion");
    }

    public validateEmailDeletion() {
        const requestBody = {
            identifier: this.email,
            channel: AlertChannel.EMAIL,
            storeId: this.storeId,
            zoneCode: this.zone.zoneCode
        } as AlertSettingsRequest;
        this.alertService.deleteAlert(requestBody).then(alertSettings => {
            EventBus.$emit(EventBus.REFRESH_ALERT_SETTINGS, alertSettings);
        })
    }
}
